import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { backgroundColorDarkTheme } from 'styles/global.styles';

interface PageLayoutProps {
  background?: 'white' | 'light' | 'default';
  children: ReactNode;
}

const PageLayoutComponent: React.FC<PageLayoutProps> = ({
  background = 'default',
  children,
}) => {
  const { pathname } = useLocation();

  return (
    <Box
      width="100vw"
      height="100vh"
      sx={{
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: backgroundColorDarkTheme,
      }}
    >
      {children}
    </Box>
  );
};

export default PageLayoutComponent;
